<template>
  <transition name="modal" appear>
    <div class="modal-overlay">
      <span class="modal-spinner"></span>
      <span>&nbsp;</span>
      <span class="modal-text">{{ spinnerMessage }}</span>
    </div>
  </transition>
</template>
<script>
export default {
  props: ["spinnerMessage"]
};
</script>
<style scoped>
.modal-overlay {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: fixed;
  z-index: 9999;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3);
}

.modal-text {
  word-break: break-all;
  font-size: larger;
  font-weight: blod;
  color: white;
  margin: 0 1.5em 0 1.5em;
}

.modal-spinner {
  width: 2rem;
  height: 2rem;
  vertical-align: text-bottom;
  border: 0.25em solid currentColor;
  border-right-color: transparent;
  border-radius: 50%;
  -webkit-animation: modal-spinner 0.75s linear infinite;
  animation: modal-spinner 0.75s linear infinite;
  color: #007bff !important;
}

@-webkit-keyframes modal-spinner {
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@keyframes modal-spinner {
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
</style>
